import React from "react";
import { siteData } from "../mock";

const About = () => {
  return (
    <div className="bg-[#05070d]">
      <section className="relative pt-36 pb-20 bg-gradient-to-br from-[#05070d] via-[#0b1220] to-[#05070d]">
        <div className="absolute inset-0 dark-grid" />
        <div className="relative max-w-7xl mx-auto px-5 md:px-8 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <span className="text-xs font-semibold tracking-[0.25em] text-blue-400">ABOUT</span>
            <h1 className="mt-3 text-4xl md:text-5xl font-bold tracking-tight text-white">
              {siteData.about.title}
            </h1>
            <p className="mt-5 text-lg text-white/80 leading-relaxed">
              {siteData.about.lead}
            </p>
            <div className="mt-5 space-y-4 text-white/70 leading-relaxed">
              {siteData.about.paragraphs.map((p, i) => (<p key={i}>{p}</p>))}
            </div>
          </div>
          <div className="relative">
            <img
              src={siteData.images.cloud}
              alt="Astronaut in deep space"
              className="w-full h-[440px] object-cover rounded-2xl shadow-2xl ring-1 ring-white/10"
            />
          </div>
        </div>
      </section>

      <section className="py-20 bg-[#080b14]">
        <div className="max-w-7xl mx-auto px-5 md:px-8">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-white text-center">Our values</h2>
          <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-5">
            {siteData.about.values.map((v, i) => (
              <div key={i} className="p-7 rounded-xl border border-white/10 bg-white/[0.03] hover:border-blue-500/60 hover:bg-white/[0.06] transition-all">
                <p className="text-sm font-semibold text-blue-400">0{i + 1}</p>
                <h3 className="mt-2 text-xl font-bold text-white">{v.title}</h3>
                <p className="mt-2 text-white/70 leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
